import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket/store'
import { type IResponseCallHeldEnded } from 'entities/Call/api/types'
import { useEntitiesContext } from 'entities/EntitiesExport'

// Backend pusher event: the customer leg of a held call has been disconnected
// (caller hung up while parked in the hold queue). The agent SDK leg for a
// held call is already dead, so this broadcast is the only signal that the
// held card is stale and should disappear.
export const useEventCallHeldEnded = () => {
  const { websocket, callStore } = useEntitiesContext()

  const handle = (data: IResponseCallHeldEnded) => {
    callStore.markHeldCallEnded(data.call_sid)
  }

  useEffect(() => websocket.on(WebsocketEvent.CallHeldEnded, handle), [])
}
